// @TODO: <HEALTH2019>
(function () {
    /**
     * Works with formats:
     * ddd
     * ddd.dd
     * ddd,dd
     */
    App.filter('currencyFormatter', currencyFormatter);
    currencyFormatter.$inject = [];
    
    function currencyFormatter() {
        return function (value) {
            value = value.replace(/,/g, '.');
            value = parseFloat(value).toFixed(2);
            value = value.replace(/\./g, ',');

            return value + ' zł';
        }
    }
})();
// @TODO: </HEALTH2019>
